import Api from "@/services/service-v2";

export const fetchPropertyList = (id) =>
  Api().$http.get(`/cap/users/partner/property-list/${id}`);

export const fetchPropertyDetails = (id) =>
  Api().$http.get(`/cap/users/partner/get-detail/${id}`);
  
export const updateUnit = (payload) =>
  Api().$http.put(`catalog/api/item/unit/${payload.id}`, payload.data);

export const createUnit = (payload) =>
  Api().$http.post(`/catalog/api/item/unit`, payload);

export const totalUnitList = (id) =>
  Api().$http.get(`/catalog/api/item/total-unit/${id}`);

export const fetchUnitDetails = (payload) =>
  Api().$http.get(
    `/catalog/api/item/filter?type=UNIT&provider=${payload.id}&Bathrooms=${payload.bath}&Bedrooms=${payload.bed}&page=${payload.page}`
  );
  
export const unitData = (id) =>
  Api().$http.get(`/catalog/api/catalog/read/catalog/item/${id}`);
